import ClosedBusniessIcon from "../assets/SVGs/Info/ClosedBusniessIcon";
import GeneralInfoIcon from "../assets/SVGs/Info/GeneralInfoIcon";
import MembershipPaymentsIcon from "../assets/SVGs/Info/MembershipPaymentsIcon";
import PointerIcon from "../assets/SVGs/Info/PointerIcon";
import ReferralsIcon from "../assets/SVGs/Info/ReferralsIcon";
import VisitorsIcon from "../assets/SVGs/Info/VisitorsIcon";
import WeeklyMeetsIcon from "../assets/SVGs/Info/WeeklyMeetsIcon";
import WeeklyMeetUpIcon from "../assets/SVGs/Info/WeeklyMeetUpIcon";

export const emailRegex =
  /^[\w!#$%&’*+/=?`{|}~^-]+(?:\.[\w!#$%&’*+/=?`{|}~^-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}$/;

export const membershipTabs = [
  {
    label: "General Info",
    icon: GeneralInfoIcon,
  },
  {
    label: "Payments",
    icon: MembershipPaymentsIcon,
  },
  {
    label: "Weekly",
    icon: WeeklyMeetsIcon,
  },
  {
    label: "Meet-Up",
    icon: WeeklyMeetUpIcon,
  },
  {
    label: "Referrals",
    icon: ReferralsIcon,
  },
  {
    label: "Closed Business",
    icon: ClosedBusniessIcon,
  },
  {
    label: "Visitors",
    icon: VisitorsIcon,
  },
  {
    label: "Points",
    icon: PointerIcon,
  },
];

export const addedMembersColumns = [
  { field: "first_name", headerName: "First Name", flex: 1, minWidth: 150 },
  { field: "last_name", headerName: "Last Name", flex: 1, minWidth: 150 },
  { field: "company", headerName: "Company", flex: 1, minWidth: 150 },
  { field: "chair", headerName: "Chair", flex: 1, minWidth: 150 },
];

export const defaultEditFormState = {
  open: false,
  id: null,
  title: null,
};

export const weeklyMeetColumns = [
  { field: "weekly_meet_date", headerName: "Weekly Meet Date", flex: 1 },
];
